export const enum ClickToPayAdapterName {
  hpp = "hpp",
}
